const ACCESS_PREFIX = "answerShareAccess:";

export type ShareAccessSession = {
  accessToken: string;
  expiresAt?: string | null;
};

function storageKey(shareToken: string): string {
  return `${ACCESS_PREFIX}${shareToken}`;
}

export function getShareAccessSession(
  shareToken: string,
): ShareAccessSession | null {
  try {
    const raw = sessionStorage.getItem(storageKey(shareToken));
    if (!raw) return null;

    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;

    const accessToken = (parsed as ShareAccessSession).accessToken?.trim();
    if (!accessToken) return null;

    const expiresAt = (parsed as ShareAccessSession).expiresAt ?? null;
    if (expiresAt) {
      const time = new Date(expiresAt).getTime();
      if (!Number.isNaN(time) && time <= Date.now()) {
        clearShareAccessSession(shareToken);
        return null;
      }
    }

    return { accessToken, expiresAt };
  } catch {
    return null;
  }
}

export function saveShareAccessSession(
  shareToken: string,
  session: ShareAccessSession,
): void {
  sessionStorage.setItem(storageKey(shareToken), JSON.stringify(session));
}

export function clearShareAccessSession(shareToken: string): void {
  sessionStorage.removeItem(storageKey(shareToken));
}
